import { Attributes, DateUtils, Misc, Model, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class DwtReportCriteria extends Model.CriteriaBase {

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.monthStart(DateUtils.today());

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.monthEnd(DateUtils.add(DateUtils.today(), {months: 1}));

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "DWT Report Criteria";
    }
}